import { useState, useEffect } from 'react'
import useAxiosPrivate from '../../../hooks/useAxiosPrivate'
import { fetchKbHome } from '../api/knowledgeBaseApi'
import type { KbHomeData } from '../types'
import HeroSection from '../components/HeroSection'
import CategoryGrid from '../components/CategoryGrid'
import QuickStartGuide from '../components/QuickStartGuide'
import FAQSection from '../components/FAQSection'
import KeyboardShortcuts from '../components/KeyboardShortcuts'
import KBSkeleton from '../components/KBSkeleton'

interface HomePageProps {
    onSelectCategory: (slug: string) => void
    onSelectArticle: (slug: string) => void
    onSearchSubmit: (query: string) => void
    onOpenSearch: () => void
}

const HomePage = ({
    onSelectCategory,
    onSelectArticle,
    onSearchSubmit,
    onOpenSearch,
}: HomePageProps) => {
    const axiosPrivate = useAxiosPrivate()
    const [data, setData] = useState<KbHomeData | null>(null)
    const [loading, setLoading] = useState(true)
    const [searchQuery, setSearchQuery] = useState('')

    useEffect(() => {
        let cancelled = false
        setLoading(true)
        fetchKbHome(axiosPrivate)
            .then((res) => {
                if (!cancelled) setData(res)
            })
            .catch(() => {})
            .finally(() => {
                if (!cancelled) setLoading(false)
            })
        return () => {
            cancelled = true
        }
    }, [axiosPrivate])

    if (loading || !data) {
        return <KBSkeleton variant="home" />
    }

    return (
        <>
            <HeroSection
                searchQuery={searchQuery}
                onSearchChange={setSearchQuery}
                onSearchSubmit={() => onSearchSubmit(searchQuery)}
                onOpenSearch={onOpenSearch}
                stats={data.stats}
            />
            <div className="kb-container">
                <CategoryGrid
                    categories={data.categories}
                    onSelectCategory={onSelectCategory}
                />
                <QuickStartGuide steps={data.quick_start_steps} />
                <FAQSection faqs={data.faqs} />
                <KeyboardShortcuts shortcuts={data.shortcuts} />
            </div>
        </>
    )
}

export default HomePage
